module.exports = __webpack_public_path__ + "img/kjicon5.9e1c9be4.svg";